import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getMe } from "../../redux/slices/authSlice";

const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();


 useEffect(() => {
  const token = localStorage.getItem("token");
  console.log("🔄 AUTH INITIALIZER TOKEN:", token);

  if (token) {
    console.log("🔄 DISPATCHING getMe()");
    dispatch(getMe());
  }
}, [dispatch]);


  return children;
};

export default AuthInitializer;
